/**
 * WebhooksTabs — the strip shared by the three pages of the 管理 › Webhooks
 * entry: health (the landing tab), events and failures. The tabs and their
 * labels live in `components/layout/nav-groups.ts` (`webhooks`). The v4 shell
 * (#2476) had put them on one strip with the two audit ledgers; the admin group
 * split that strip in two (`AuditTabs` in `features/audit` is the other half).
 *
 * The strip renders BENEATH the page title, through each resource's
 * `host.listTabs`; the bespoke health page composes it by hand.
 *
 * The failure count rides on the Failures TAB rather than on a page title: a
 * number beside a title would read as a count of the titled thing.
 */
import { useTranslation } from 'react-i18next';
import { Badge } from '@resource-kit/ui/react';
import { NavGroupTabs } from '@components/layout/NavGroupTabs';
import { ROUTES } from '@lib/routes';
import { useWebhookFailuresCount } from '@hooks/useWebhookFailuresCount';

export function WebhooksTabs() {
  const { t } = useTranslation();
  // `.count` — the response is an envelope, not a bare number. This is the
  // dedicated GLOBAL unresolved count, deliberately not the list's own total:
  // the list total moves with the operator's filters, so a provider filter
  // would make the badge understate the backlog.
  const openFailures = useWebhookFailuresCount().data?.count ?? 0;

  return (
    <NavGroupTabs
      group="webhooks"
      badges={{
        [ROUTES.webhooks.failures]:
          openFailures > 0 ? (
            <Badge variant="secondary" aria-label={t('webhookFailures.totalUnresolved')}>
              {openFailures}
            </Badge>
          ) : undefined,
      }}
    />
  );
}

export default WebhooksTabs;
